import React from 'react';

export default function Employee({ feature, plan, quota, unlimited }) {

    const isPlural = quota.quotaAmount > 1;

    if(unlimited)
    {

        return (
        
            <React.Fragment>
                <p>
                    <React.Fragment>
                        <strong>Unlimited</strong> Employees
                    </React.Fragment>
                </p>
            </React.Fragment>
            
        );

    }

    return (

        <React.Fragment>

            <p><strong>{quota.quotaAmount}</strong>
            { isPlural &&
                <React.Fragment> Employees</React.Fragment>
            }
            {!isPlural &&
                <React.Fragment> Employee</React.Fragment>
            }
            </p>

        </React.Fragment>

    );

};